import module from 'module';
const templateUrl = require('./gl-transactions.template.html');


module.component('glTransactions', {
  templateUrl,
});